import { Log } from '../../shared/log';
const log = new Log('QldGovSearchService');

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AppConfig } from '../../app.config';
import { UrlBuilder } from '../url/url.builder';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class QldGovSearchService {
  private searchUrl;

  constructor(
    private http: Http,
    private appConfig: AppConfig
  ) {
    this.searchUrl = this.appConfig.getValue('qldGovSearchUrl');
  }
  getQldGovSearchResults(searchTerm, profile): Promise<Object> {
    const urlBuilder = new UrlBuilder();
    const params = {
      'collection': 'qld-gov',
      'fmt': 'json++',
      'sort': '0',
      'profile': profile,
      'partial_query': searchTerm
    };
    const qldGovSearchUrl = urlBuilder.build(this.searchUrl, params);
    return this.http.get(qldGovSearchUrl)
      .toPromise()
      .then((response) => {
        // return empty array if error in json
        let results;
        try {
          results = response.json();
        } catch (error) {
          results = [];
        }
        return results;
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    log.error(error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./app/services/qldgovsearch/qldgovsearch.service.ts